import templates from '@mfe/components/templates';
import { config } from '@mfe/config';
import { configStore } from '@mfe/store';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { TriggerEventMixin } from '@mfec/lit/mixins/TriggerEventMixin';
import { LitElement } from 'lit';

export const BaseComponent = TemplatingMixin(
  TriggerEventMixin(LitElement, config.componentTagName),
  configStore.theme,
  templates,
);
